function createSingleUniformBGL(engine, label, visibility) {
  return engine._device.createBindGroupLayout({
    label,
    entries: [{ binding: 0, visibility, buffer: { type: "uniform" } }]
  });
}

export { createSingleUniformBGL };
//# sourceMappingURL=bgl-helpers.js.map
